import LoadingPage from '@/common/pages/LoadingPage';
import RateImage from '@/modules/Statistics/assets/icons/rate.svg?react';
import { useQuery } from '@tanstack/react-query';
import { Flex } from 'styled-system/jsx';
import { getSurveyChartQueryOptions } from '../../queries/getSurveyChart/getSurveyChartQueryOptions';
import { getSurveySummaryQueryOptions } from '../../queries/getSurveySummary/getSurveySummaryQueryOptions';
import RankingCard from '../card/RankingCard';
import BarChart from '../charts/BarChart';
import SatisfactionSurvey from './SatisfactionSurvey';

export default function StatisticSurveySection() {
  const { data, isPending } = useQuery(
    getSurveySummaryQueryOptions({ user_type: 'adjuster' }),
  );

  const { data: SurveyChartData, isPending: SurveyChartPending } = useQuery(
    getSurveyChartQueryOptions({ user_type: 'adjuster' }),
  );

  const labels = SurveyChartData?.map((item) => item.month_name) ?? [];

  const values = SurveyChartData?.map((item) => item.count ?? 0) ?? [];

  return (
    <Flex flexDirection="column" gap="5px">
      {isPending ? (
        <LoadingPage height="30vh" />
      ) : (
        <>
          <RankingCard
            rank={data?.average_total_score}
            label="رضایت سنجی"
            totalAssessors={data?.total_answered}
            themeColor="orange"
            icon={<RateImage />}
          />
          <SatisfactionSurvey data={data} />
        </>
      )}
      {SurveyChartPending ? (
        <LoadingPage height="20vh" />
      ) : (
        <BarChart
          labels={labels}
          values={values}
          theme={'yellow'}
          maxValues={values}
          axisMax={5}
          integerValues
        />
      )}
    </Flex>
  );
}
